// extracted by mini-css-extract-plugin
export default {"salesBanner":"SalesCounter_salesBanner__0GdUq","salesText":"SalesCounter_salesText__VtYo0","inBottomBar":"SalesCounter_inBottomBar__ywDKe"};